import React from "react";
import '../../CSS/Consulat_honoraires.css';
import Consulat from "../composant_reutilisable/ConsulatsData";
import MenuSection from "./menuSection"; // AJOUT: Importer MenuSection
import { useTranslation } from 'react-i18next'; // AJOUT: Importer useTranslation

const Consulat_honoraires = () => {

    const { t } = useTranslation(); // AJOUT: Hook de traduction

    return (
        <div className="Consulat_honoraires-container">
            <div className="Consulat_honoraires-content">
                {/* AJOUT: MenuSection pour garder la navigation */}
                <MenuSection title={t('menuSection.honoraryConsulates')} />
                
                {/* Votre contenu existant */}
                <Consulat/>
            </div>
        </div>
    );
};

export default Consulat_honoraires;